var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('GmapMarker',{attrs:{"position":_vm.location,"clickable":false,"draggable":false,"zIndex":1,"icon":_vm.icon}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }